// extracted by mini-css-extract-plugin
export var acitonButtons = "_ai-0";
export var additionalIcon = "_ai-f";
export var block = "_ai-1";
export var blockContent = "_ai-7";
export var blockDescription = "_ai-8";
export var blockIcon = "_ai-9";
export var blockTitle = "_ai-6";
export var border = "_ai-a";
export var center = "_ai-l";
export var edge = "_ai-b";
export var edgeLabel = "_ai-c";
export var edgePath = "_ai-d";
export var error = "_ai-e";
export var flowchart = "_ai-g";
export var flowchartContent = "_ai-h";
export var highlighted = "_ai-3";
export var hover = "_ai-4";
export var icon = "_ai-i";
export var left = "_ai-m";
export var navButton = "_ai-j";
export var navButtons = "_ai-k";
export var right = "_ai-n";
export var selected = "_ai-2";
export var small = "_ai-5";